import React, { useEffect } from 'react';
import CaseStudy from '../CaseStudy';
import Cta from '../Cta';
import Div from '../Div';
import Hero3 from '../Hero/Hero3';
import LogoList from '../LogoList';
import MovingText from '../MovingText';
import Portfolio2 from '../Portfolio/Portfolio2';
import Portfolio3 from '../Portfolio/Portfolio3';
import SectionHeading from '../SectionHeading';
import TestimonialSlider from '../Slider/TestimonialSlider';
import Spacing from '../Spacing';
import { pageTitle } from '../../helper';
const heroSocialLinks = [
  {
    name: 'FaceBook',
    links: '/',
  },
  {
    name: 'Instagram',
    links: '/',
  },
];
const portfolioData = [
  {
    title: 'Arcade Racing & Combat Games',
    subtitle: 'Kids & Teens',
    // btnText: 'See Details',
    // btnLink: '/portfolio/portfolio-details',
    imageUrl: '/images/img/image_33.webp',
    category: 'Kids & Teens',
  },
  {
    title: 'Multiplayer VR and Console Gaming',
    subtitle: 'Gamer Meetups',
    // btnText: 'See Details',
    // btnLink: '/portfolio/portfolio-details',
    imageUrl: '/images/img/image_29.webp',
    category: 'Gamer Meetups',
  },
  {
    title: 'Arcade machines, high-end video games',
    subtitle: 'Indoor Gaming Arena',
    // btnText: 'See Details',
    // btnLink: '/portfolio/portfolio-details',
    imageUrl: '/images/img/image_27.webp',
    category: 'Indoor Gaming Arena',
  },
  {
    title: 'Kid-Friendly Interactive Games',
    subtitle: 'Weekend Family Outings',
    // btnText: 'See Details',
    // btnLink: '/portfolio/portfolio-details',
    imageUrl: '/images/img/image_23.webp',
    category: 'Weekend Family Outings',
  },
];

export default function CreativePortfolioHome() {
  pageTitle('GameGalaxy');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Start Hero Section */}
      <Hero3
        title="GameGalaxy"
        btnLink=""
        btnText={''}
        socialLinksHeading="Follow Us"
        heroSocialLinks={heroSocialLinks}
        bgImageUrl="./images/hero_bg_4.jpeg"
      />
      {/* End Hero Section */}

      {/* Start Portfolio Section */}
      <Spacing lg="150" md="80" />
      {portfolioData.map((item, index) =>
        index % 2 === 0 ? (
          <Div key={index}>
            <Portfolio2
              title={item.title}
              subtitle={item.subtitle}
              // btnText={item.btnText}
              // btnLink={item.btnLink}
              imageUrl={item.imageUrl}
              category={item.category}
            />
            <Spacing lg="100" md="70" />
          </Div>
        ) : (
          <Div key={index}>
            <Portfolio3
              title={item.title}
              subtitle={item.subtitle}
              btnText={item.btnText}
              // btnLink={item.btnLink}
              imageUrl={item.imageUrl}
              category={item.category}
            />
            <Spacing lg="100" md="70" />
          </Div>
        ),
      )}
      {/* End Portfolio Section */}

      {/* Start Case Study Section */}
      <Spacing lg="45" md="10" />
      <Div className="container">
        <SectionHeading
          title="Score high. Laugh loud. Repeat"
          subtitle=" Fun Zone"
          variant="cs-style1 text-center"
        />
        <Spacing lg="90" md="45" />
      </Div>
      <CaseStudy
        title="Gaming isn’t a pastime—it’s a power move"
        bgUrl="/images/case_study_2.jpeg"
        href=""
        variant="cs-style2"
      />
      <CaseStudy
        title="Push play. Power up. Game on."
        bgUrl="/images/case_study_1.jpeg"
        href=""
      />
      <Spacing lg="150" md="80" />
      {/* End Case Study Section */}

      {/* Start Testimonial Section */}
      {/* <TestimonialSlider /> */}
      {/* End Testimonial Section */}

      {/* Start MovingText Section */}
      {/* <Spacing lg="125" md="70" />
      <MovingText text="Our reputed world wide partners" />
      <Spacing lg="105" md="70" /> */}
      {/* End MovingText Section */}

      {/* Start LogoList Section */}
      {/* <Div className="container">
        <LogoList />
      </Div>
      <Spacing lg="150" md="80" /> */}
      {/* End LogoList Section */}

      {/* Start CTA Section */}
      {/* <Div className="container">
        <Cta
          title="Let’s disscuse make <br />something <i>cool</i> together"
          btnText="Apply For Meeting"
          btnLink="/contact"
          bgSrc="/images/cta_bg_3.jpeg"
        />
      </Div> */}
      {/* End CTA Section */}
    </>
  );
}
